<template>
    <div class="content">
        <div class="searchContent">
            <div class="p_select">
        <div class="search_label">部位</div>
                <el-select v-model="positionId" clearable filterable placeholder="请选择部位" @change="getListData">
                    <el-option
                            v-for="item in positionList"
                            :key="item.positionId"
                            :label="item.positionName"
                            :value="item.positionId"
                    ></el-option>
                </el-select>
            </div>
            <div class="p_select">
                  <div class="search_label">工时编号</div>
                <el-input placeholder="请输入工时编号" v-model="partsNo" clearable @change="getListData"></el-input>
            </div>
            <div class="p_select">
                <div class="search_label">工时名称</div>
                <el-input placeholder="请输入工时名称" v-model="partsName" clearable @change="getListData"></el-input>
            </div>
            <div class="p_select">
                <a class="search_btn" @click="getListData">查询</a>
            </div>
            <div class="p_select" style="float: right;">
                <a class="add_btn" @click="addItem"><i class="el-icon-plus"></i>新增</a>
            </div>


        </div>
        <div class="list_content">
            <el-table :data="templateListData" :height=winHeight :cell-style="setRowStyle"  :header-cell-style="getHeaderStyle">
                <el-table-column prop="positionName" label="部位"></el-table-column>
                <el-table-column prop="partsName" label="名称"></el-table-column>
                <el-table-column prop="partsNo" label="编号"></el-table-column>
                <el-table-column prop="price" label="金额(元)"></el-table-column>
                <el-table-column prop="defaultNum" label="默认数量"></el-table-column>
                <el-table-column prop="brandName" label="品牌"></el-table-column>
                <el-table-column prop="modelName" label="型号"></el-table-column>
                <el-table-column fixed="right" label="操作">
                    <template slot-scope="scope">
                        <el-button
                                @click="updateDiction(scope.row)"
                                type="warning"
                                size="small"
                                class="update_btn"
                        >修改</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="pagination">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    :current-page="pageNo"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
            ></el-pagination>
        </div>



        <!-- <el-dialog :visible.sync="showAddData" title="新增工时信息" width="40%" :close-on-click-modal="false" @close="noAddData">
            <el-form ref="templateForm" :model="templateForm" label-width="100px"  :rules="templateFormRules">
                <el-form-item label="所属部位:" prop="positionId">
                    <el-select v-model="templateForm.positionId" clearable placeholder="请选择所属部位" style="width: 100%">
                        <el-option
                                v-for="item in positionList"
                                :key="item.positionId"
                                :label="item.positionName"
                                :value="item.positionId"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="编号:" prop="partsNo">
                    <el-input v-model="templateForm.partsNo" placeholder="请输入编号"></el-input>
                </el-form-item>
                <el-form-item label="名称:" prop="partsName">
                    <el-input v-model="templateForm.partsName" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="单价(元):" prop="price">
                    <el-input v-model="templateForm.price" placeholder="请输入单价" type="number"></el-input>
                </el-form-item>
                <el-form-item label="默认数量:" prop="defaultNum">
                    <el-input v-model="templateForm.defaultNum" placeholder="请输入默认数量" type="number"></el-input>
                </el-form-item>

                <el-form-item label="品牌:" prop="brandName">
                    <el-input v-model="templateForm.brandName" placeholder="请输入品牌"></el-input>
                </el-form-item>
                <el-form-item label="型号:" prop="modelName">
                    <el-input v-model="templateForm.modelName" placeholder="请输入型号"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="submitAdd('templateForm')">确认新增</el-button>
                    <el-button @click="noAddData">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>

        <el-dialog :visible.sync="showEditData" title="修改工时信息" width="40%" :close-on-click-modal="false" @close="noUpdateData">
            <el-form ref="templateForm" :model="templateForm" label-width="100px"  :rules="templateFormRules">
                <el-form-item label="所属部位:" prop="positionId">
                    <el-select v-model="templateForm.positionId" clearable placeholder="请选择所属部位" style="width: 100%">
                        <el-option
                                v-for="item in positionList"
                                :key="item.positionId"
                                :label="item.positionName"
                                :value="item.positionId"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="编号:" prop="partsNo">
                    <el-input v-model="templateForm.partsNo" placeholder="请输入编号" ></el-input>
                </el-form-item>
                <el-form-item label="名称:" prop="partsName">
                    <el-input v-model="templateForm.partsName" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="单价(元):" prop="price">
                    <el-input v-model="templateForm.price" placeholder="请输入单价" type="number"></el-input>
                </el-form-item>
                <el-form-item label="默认数量:" prop="defaultNum">
                    <el-input v-model="templateForm.defaultNum" placeholder="请输入默认数量" type="number"></el-input>
                </el-form-item>

                <el-form-item label="品牌:" prop="brandName">
                    <el-input v-model="templateForm.brandName" placeholder="请输入品牌"></el-input>
                </el-form-item>
                <el-form-item label="型号:" prop="modelName">
                    <el-input v-model="templateForm.modelName" placeholder="请输入型号"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="submitEdit('templateForm')">确认修改</el-button>
                    <el-button @click="noUpdateData">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog> -->

        <el-drawer
        title="新增工时信息"
        :visible.sync="showAddData"
        direction="rtl"
        :wrapperClosable=true
        @close="noAddData">
           <el-form ref="templateForm" :model="templateForm" label-width="100px"  :rules="templateFormRules">
                <el-form-item label="所属部位:" prop="positionId">
                    <el-select v-model="templateForm.positionId" clearable placeholder="请选择所属部位" style="width: 100%">
                        <el-option
                                v-for="item in positionList"
                                :key="item.positionId"
                                :label="item.positionName"
                                :value="item.positionId"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="编号:" prop="partsNo">
                    <el-input v-model="templateForm.partsNo" placeholder="请输入编号"></el-input>
                </el-form-item>
                <el-form-item label="名称:" prop="partsName">
                    <el-input v-model="templateForm.partsName" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="单价(元):" prop="price">
                    <el-input v-model="templateForm.price" placeholder="请输入单价" type="number"></el-input>
                </el-form-item>
                <el-form-item label="默认数量:" prop="defaultNum">
                    <el-input v-model="templateForm.defaultNum" placeholder="请输入默认数量" type="number"></el-input>
                </el-form-item>

                <el-form-item label="品牌:" prop="brandName">
                    <el-input v-model="templateForm.brandName" placeholder="请输入品牌"></el-input>
                </el-form-item>
                <el-form-item label="型号:" prop="modelName">
                    <el-input v-model="templateForm.modelName" placeholder="请输入型号"></el-input>
                </el-form-item>

            </el-form>
            <div class="position_box_btn">
                <a class="sure_btn" @click="submitAdd('templateForm')">确认新增</a>
                <a class="cancel_btn" @click="noAddData">取消</a>
            </div>
      </el-drawer>


    <el-drawer
      title="修改工时信息"
      :visible.sync="showEditData"
      direction="rtl"
      :wrapperClosable=true
      @close="noUpdateData">
        <el-form ref="templateForm" :model="templateForm" label-width="100px"  :rules="templateFormRules">
                <el-form-item label="所属部位:" prop="positionId">
                    <el-select v-model="templateForm.positionId" clearable placeholder="请选择所属部位" style="width: 100%">
                        <el-option
                                v-for="item in positionList"
                                :key="item.positionId"
                                :label="item.positionName"
                                :value="item.positionId"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="编号:" prop="partsNo">
                    <el-input v-model="templateForm.partsNo" placeholder="请输入编号" ></el-input>
                </el-form-item>
                <el-form-item label="名称:" prop="partsName">
                    <el-input v-model="templateForm.partsName" placeholder="请输入名称"></el-input>
                </el-form-item>
                <el-form-item label="单价(元):" prop="price">
                    <el-input v-model="templateForm.price" placeholder="请输入单价" type="number"></el-input>
                </el-form-item>
                <el-form-item label="默认数量:" prop="defaultNum">
                    <el-input v-model="templateForm.defaultNum" placeholder="请输入默认数量" type="number"></el-input>
                </el-form-item>

                <el-form-item label="品牌:" prop="brandName">
                    <el-input v-model="templateForm.brandName" placeholder="请输入品牌"></el-input>
                </el-form-item>
                <el-form-item label="型号:" prop="modelName">
                    <el-input v-model="templateForm.modelName" placeholder="请输入型号"></el-input>
                </el-form-item>

            </el-form>
        <div class="position_box_btn">
            <a class="sure_btn" @click="submitEdit('templateForm')">确认修改</a>
            <a class="cancel_btn" @click="noUpdateData">取消</a>
        </div>
    </el-drawer>

    </div>
</template>

<script>
  import net from "../../assets/js/public";
  export default {
    name: "repairOrderOrg", //设备维修工单管理查询，分页 (站点员工)
    data() {
      return {
        templateListData:[],
        total:0,
        pageNo:1,
        pageSize:10,
        partsNo:'',
        partsName:'',
        orgId:'',
        orgName:'',
        showType:'1',
        showAddData: false,
        templateForm:{
          orgId:'',
          positionId:'',
          showType:'',
          partsNo:'',
          partsName:'',
          brandName:'',
          modelName:'',
          price:'',
          defaultNum:1,
        },
        templateFormRules: { // 表单规则
          orgId: [{ required: true, message: '请选择站点', trigger: 'change' }],
          positionId: [{ required: true, message: '请选择部位', trigger: 'change' }],
          partsName: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          price: [{ required: true, message: '请输入单价', trigger: 'change' }],
          defaultNum: [{ required: true, message: '请输入默认数量', trigger: 'change' }],

        },
        positionId:'',
        positionList:[],
        showEditData: false,
        lastRequestParm:'',

        winHeight:'200',

      };
    },
    created() {
      var signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      this.orderPageShowOrgName = signInfo.orgId == 0;
      this.orgId = signInfo.orgId;
      this.templateForm.orgId = signInfo.orgId;
      this.orgName = signInfo.orgName;
      this.getPositionList();

      this.getListData()
    },
    methods: {
      getHeaderStyle() {
        return "background-color:#F3F7FB; color: #364556; text-align: left;font-size: 14px;height: 48px;font-weight: 500;font-family: 'PingFang SC';";
      },
      setRowStyle(row, column, rowIndex, columnIndex) {
        if(row.columnIndex == 0){
          return 'color: #0D0E12;font-weight: 500;font-size: 14px;'
        }else{
          return 'color: #0D0E12;font-weight: 400;'
        }
      },
      // 获取站点所有部位
      getPositionList(callback){
        let that = this;
        const params = {
          orgId: this.orgId,
          showType: 0,
        }
        net.request("admin/manage/parts/getPositionList","post",params).then(res => {
          if (res.code === 0) {
            this.positionList = res.data
            let tag = false;
            if(callback && this.positionList!=null && this.positionList.length>0){
              this.positionList.forEach(function(e){
                if(e.positionId ===  that.positionId){
                  tag = true;
                }
              });
            }
            if(!tag){
              that.positionId = ''
              that.templateListData = []
              that.total = 0
              that.pageNo = 1
            }
          } else {
            net.message(this, "获取数据失败", "warning");
          }
        })
      },

      getListData() {
        const params = {
          pageNo: this.pageNo,
          pageSize: this.pageSize,
          partsNo:this.partsNo || null,
          partsName:this.partsName || null,
          positionId: this.positionId || null,
          orgId: this.orgId,
          showType: 1,
        }
        let p = params.partsNo + "," + params.partsName + "," + params.positionId+"," + params.orgId + "," + params.showType;
        if(this.lastRequestParm != p){
          this.lastRequestParm = p;
          params.pageNo = 1;
        }
        net.request("admin/manage/parts/selectPartsList","post", null, params).then(res => {
          if (res.code === 0) {

            let data = res.data.rows
            data.forEach(item => {
              item.price = item.price/100
            })
            this.templateListData = data
            this.total = res.data.total
            const windiwHight = document.documentElement.clientHeight || document.body.clientHeight // 可视屏幕高度
            this.winHeight = windiwHight - 255
          } else {
            net.message(this, "获取数据失败", "warning");
          }
        })
      },
      addItem(showType){
        this.showAddData = true
        this.templateForm.orgId = this.orgId
        this.templateForm.positionId = ''
        this.templateForm.showType = this.showType
        this.templateForm.partsNo = ''
        this.templateForm.partsName = ''
        this.templateForm.brandName = ''
        this.templateForm.modelName = ''
        this.templateForm.price = ''
        this.templateForm.defaultNum = 1
      },
      submitAdd(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const params = {
              brandName: this.templateForm.brandName,
              modelName: this.templateForm.modelName,
              orgId: this.orgId,
              partsId: this.templateForm.partsId,
              partsName: this.templateForm.partsName,
              partsNo: this.templateForm.partsNo,
              positionId: this.templateForm.positionId,
              showType: 1,
              price: this.templateForm.price * 100,
              defaultNum: this.templateForm.defaultNum,

            }
            net.request("admin/manage/parts/addParts", "post", null, params).then(res => {
              if (res.code === 0) {
                net.message(this, res.msg, "success");
                this.showAddData = false
                this.getListData()
              } else {
                net.message(this, res.msg, "warning");
              }
              this.showAddData = false
              this.getListData()
            });
          } else {
            return false;
          }
        });

      },
      noAddData(){
        this.showAddData = false
        this.getListData()
      },
      updateDiction(row){
        console.log(row.showType)
        this.showEditData = true
        this.templateForm = row
        this.templateForm.showType = row.showType+''
      },
      submitEdit(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            const params  = {
              brandName: this.templateForm.brandName,
              modelName: this.templateForm.modelName,
              orgId: this.orgId,
              partsId: this.templateForm.partsId,
              partsName: this.templateForm.partsName,
              partsNo: this.templateForm.partsNo,
              positionId: this.templateForm.positionId,
              showType: 1,
              price: this.templateForm.price * 100,
              defaultNum: this.templateForm.defaultNum,
            }
            net.request("admin/manage/parts/editParts", "post",null, params).then(res => {
              if (res.code === 0) {
                net.message(this, res.msg, "success");
                this.showEditData = false
                this.getListData()
              } else {
                net.message(this, res.msg, "warning");
              }
              this.showEditData = false
              this.getListData()
            });
          } else {
            return false;
          }
        });
      },
      noUpdateData(){
        this.showEditData = false
        this.getListData()
      },

      handleSizeChange(val) {
        this.pageSize = val;
        this.getListData()
      },
      handleCurrentChange(val) {
        this.pageNo = val
        this.getListData()
      },
    }
  };
</script>

<style lang='less' scoped>
  .content {
    padding-left: 24px;
    .searchContent {
        height: 60px;
        background: #fff;
        margin: 24px 0 0px 0;
        /*display: flex;*/
        /*flex-direction: row;*/
        padding-left: 24px;
        padding-top: 24px;
        .p_select {
            display: flex;
            padding: 0 24px 24px 0;
            font-size: 12px;
            float: left;
            .search_label{
              font-family: 'PingFang SC';
              font-style: normal;
              margin-right: 12px;
              font-weight: 500;
              font-size: 14px;
              line-height: 40px;
              color: #787E86;
              white-space:nowrap
            }

            .el-input , .el-select{
              width: 160px;
            }
          }
        .search_btn {
          width: 76px;
          height: 36px;
            line-height: 36px;
          background: #2B54FC;
          box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
          border-radius: 4px;
          color: #FFFFFF;
          font-size: 14px;
        }
        .add_btn {
          width: 76px;
          height: 36px;
            line-height: 36px;
          background: rgba(148, 170, 204, 0.08);
          border: 1px solid #2B54FC;
          border-radius: 4px;
          font-size: 14px;
          color: #2B54FC;
        }

    }
    .list_content {
      background: #fff;
      padding-left: 24px;
        padding-right: 24px;
    }
  }
  /deep/ .el-table th.el-table__cell {
      background: #F3F7FB !important;
      color: #364556;
  }


    .pagination {
        position: relative;
        margin-top: 0;
        background: #fff;
        padding-top: 24px;
        padding-bottom: 10px;
        .el-pagination {
            position: absolute;
            right: 24px;
            .el-pager li:not(.disabled) {
                .active {
                    background: #009688 !important;
                }
            }
        }
    }

    .el-pagination.is-background .el-pager li:not(.disabled).active {
        background: #009688;
    }
    .select_box {
        text-align: left;
        margin-bottom: 10px;
        .select_title {
            display: inline-block;
            width: 100px;
            text-align: right;
            margin-right: 20px;
        }
    }
    .update_btn {
      width: 54px;
      height: 28px;
      background: rgba(148, 170, 204, 0.08);
      border: 1px solid #E3E7ED;
      border-radius: 14px;
      font-size: 12px;
      color: #364556;
      text-align: center;
    }
</style>
